import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { DollarSign } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function LawFirmsFeesPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Honorários"
      description="Gerencie os honorários dos processos e clientes."
      icon={DollarSign}
    />
  
    </MainLayout>);
}

